import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";

export function RestoreTestCard({ d, onDone }) {
  const [busy, setBusy] = useState(false);
  const t = d.restore_test;
  const run = async (source = "local") => {
    setBusy(true);
    try { const { data } = await api.post(`/backup/restore-test?source=${source}`); toast[data.status === "BAŞARILI" ? "success" : "error"](`${source === "s3" ? "S3 " : ""}Restore testi ${data.status}`); onDone(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="panel p-4" data-testid="restore-test-card">
      <div className="flex items-center justify-between gap-2 mb-2">
        <h3 className="font-semibold flex items-center gap-2"><FlaskConical className="h-4 w-4" />Felaket Kurtarma Testi</h3>
        {d.is_super && <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={() => run()} disabled={busy} data-testid="restore-test-run-button">{busy ? "Test sürüyor…" : "Restore Testi Çalıştır"}</Button>
          {d.s3.configured && <Button size="sm" variant="outline" onClick={() => run("s3")} disabled={busy} data-testid="restore-test-s3-button">S3'ten Restore Testi</Button>}
        </div>}
      </div>
      <p className="text-[12px] text-slate-500 mb-2">Canlı veriye dokunmaz: yedek alır, ayrı test veritabanına ({"istoc_erp_drtest"}) geri yükler, doğrular, test DB'yi silip tekrar yükler ve sonunda test DB'yi temizler.</p>
      {t ? (
        <div data-testid="restore-test-last">
          <div className={`text-[13px] font-semibold ${t.status === "BAŞARILI" ? "text-emerald-700" : "text-rose-700"}`}>Son test{t.source === "s3" ? " (S3 kopyasından)" : ""}: {t.status} · {formatDate(t.at)} · {t.by} · {t.duration_s} sn</div>
          <ol className="list-decimal pl-5 mt-1 text-[12px] text-slate-600 space-y-0.5">{t.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
        </div>
      ) : <div className="text-[13px] text-amber-700" data-testid="restore-test-none">Henüz restore testi yapılmadı</div>}
    </div>
  );
}
